"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EExternalActionConnectionStatus = exports.EMeteorWalletExternalActionSource = exports.EWalletExternalActionStatus = exports.EWalletExternalAction_SignIn_AccessType = exports.EMeteorWalletSignInType = exports.EWalletExternalActionType = exports.MeteorActionError = void 0;
const ExternalActionErrorMessages_1 = require("./ExternalActionErrorMessages");
class MeteorActionError extends Error {
    constructor(reason, previousError) {
        var _a, _b;
        super();
        if (reason.message == null) {
            reason.message = (0, ExternalActionErrorMessages_1.getExternalActionErrorMessageForEndTag)((_b = (_a = reason.endTags) === null || _a === void 0 ? void 0 : _a[reason.endTags.length - 1]) !== null && _b !== void 0 ? _b : "unknown");
        }
        this._reason = reason;
        this.message = reason.message;
        this.name = "MeteorActionError";
        this.cause = previousError;
    }
}
exports.MeteorActionError = MeteorActionError;
var EWalletExternalActionType;
(function (EWalletExternalActionType) {
    EWalletExternalActionType["login"] = "login";
    EWalletExternalActionType["sign"] = "sign";
    EWalletExternalActionType["logout"] = "logout";
})(EWalletExternalActionType = exports.EWalletExternalActionType || (exports.EWalletExternalActionType = {}));
var EMeteorWalletSignInType;
(function (EMeteorWalletSignInType) {
    EMeteorWalletSignInType["ALL_METHODS"] = "ALL_METHODS";
    EMeteorWalletSignInType["SELECTED_METHODS"] = "SELECTED_METHODS";
    EMeteorWalletSignInType["FULL_ACCESS"] = "FULL_ACCESS";
})(EMeteorWalletSignInType = exports.EMeteorWalletSignInType || (exports.EMeteorWalletSignInType = {}));
var EWalletExternalAction_SignIn_AccessType;
(function (EWalletExternalAction_SignIn_AccessType) {
    EWalletExternalAction_SignIn_AccessType["FULL_ACCESS"] = "fullAccess";
    EWalletExternalAction_SignIn_AccessType["LIMITED_ACCESS"] = "limitedAccess";
})(EWalletExternalAction_SignIn_AccessType = exports.EWalletExternalAction_SignIn_AccessType || (exports.EWalletExternalAction_SignIn_AccessType = {}));
var EWalletExternalActionStatus;
(function (EWalletExternalActionStatus) {
    EWalletExternalActionStatus["UNCONFIRMED"] = "UNCONFIRMED";
    EWalletExternalActionStatus["PENDING"] = "PENDING";
    EWalletExternalActionStatus["SUCCESS"] = "SUCCESS";
    EWalletExternalActionStatus["FAILURE"] = "FAILURE";
})(EWalletExternalActionStatus = exports.EWalletExternalActionStatus || (exports.EWalletExternalActionStatus = {}));
var EMeteorWalletExternalActionSource;
(function (EMeteorWalletExternalActionSource) {
    EMeteorWalletExternalActionSource["website_callback"] = "wcb";
    EMeteorWalletExternalActionSource["website_post_message"] = "wpm";
    EMeteorWalletExternalActionSource["extension_injected"] = "ext";
})(EMeteorWalletExternalActionSource = exports.EMeteorWalletExternalActionSource || (exports.EMeteorWalletExternalActionSource = {}));
var EExternalActionConnectionStatus;
(function (EExternalActionConnectionStatus) {
    EExternalActionConnectionStatus["initializing"] = "initializing";
    EExternalActionConnectionStatus["connected"] = "connected";
    EExternalActionConnectionStatus["attempting_reconnect"] = "attempting_reconnect";
    EExternalActionConnectionStatus["disconnected"] = "disconnected";
    EExternalActionConnectionStatus["closed_success"] = "closed_success";
    EExternalActionConnectionStatus["closed_fail"] = "closed_fail";
    EExternalActionConnectionStatus["closed_window"] = "closed_window";
})(EExternalActionConnectionStatus = exports.EExternalActionConnectionStatus || (exports.EExternalActionConnectionStatus = {}));
//# sourceMappingURL=ExternalActionTypes.js.map